import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
import { getThemeStyle, type Mode, type Theme } from "~/features/ui/get-theme-style";
import { Icon } from "~/features/ui/icon";
import Checkmark from "~/public/icons/checkmark.svg";
import Minus from "~/public/icons/minus.svg";
type Props = {
  mode: Mode;
  theme: Theme;
  options: string[];
  feature?: string;
  featuredIn?: string;
};
export function ComparisonTableItem(props: Props) {
  const {
    mode,
    theme,
    options,
    feature,
    featuredIn
  } = props;
  const themeStyle = getThemeStyle({
    mode,
    theme
  });
  if (!feature || !featuredIn) return;
  const availabilityList = featuredIn?.split(",").map(item => item.trim()) || [];
  const isAvailableIn = (option: string) => availabilityList.includes(option);
  return <_StyledTr $_css={[{
    "borderTopWidth": "1px"
  }, themeStyle.border]}>
      <_StyledTd>
        {feature}
      </_StyledTd>
      {options.map(option => <_StyledTd2 key={option} $_css2={[{
      "borderLeftWidth": "1px",
      "padding": "2.4rem",
      "fontSize": "1.4rem",
      "lineHeight": "1.5",
      "letterSpacing": "0.014000000000000002rem",
      "fontWeight": "400",
      "@media (min-width: 1024px)": {
        "fontSize": "1.4rem",
        "lineHeight": "1.5",
        "letterSpacing": "0.014000000000000002rem",
        "fontWeight": "400"
      }
    }, themeStyle.border]}>
          <_StyledSpan $_css3={[{
        "marginTop": "-1.2rem",
        "marginBottom": "-1.2rem",
        "display": "flex",
        "height": "1.6rem",
        "width": "1.6rem",
        "alignItems": "center",
        "justifyContent": "center",
        "borderRadius": "9999px",
        "padding": "1.2rem"
      }, isAvailableIn(option) ? {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))"
      } : {
        "backgroundColor": "rgb(255 255 255 / 0.3)"
      }]}>
            <_StyledIcon icon={isAvailableIn(option) ? Checkmark : Minus} />
          </_StyledSpan>
        </_StyledTd2>)}
    </_StyledTr>;
}
var _StyledTr = /*#__PURE__*/_styled("tr").withConfig({
  componentId: "sc-sf-1e1xedh-0"
})`${p => p.$_css}`;
var _StyledTd = _styled2("td").withConfig({
  componentId: "sc-sf-1e1xedh-1"
})({
  "whiteSpace": "nowrap",
  "padding": "2.4rem",
  "fontSize": "1.4rem",
  "lineHeight": "6px !important",
  "letterSpacing": "0.014000000000000002rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "1.4rem",
    "lineHeight": "1.5",
    "letterSpacing": "0.014000000000000002rem",
    "fontWeight": "400"
  }
});
var _StyledTd2 = _styled3("td").withConfig({
  componentId: "sc-sf-1e1xedh-2"
})`${p => p.$_css2}`;
var _StyledSpan = _styled4("span").withConfig({
  componentId: "sc-sf-1e1xedh-3"
})`${p => p.$_css3}`;
var _StyledIcon = /*#__PURE__*/_styled5(Icon).withConfig({
  displayName: "comparison-table-item___StyledIcon",
  componentId: "sc-1s5d9rc-0"
})({
  "height": "1.6rem",
  "width": "1.6rem"
});